import React from 'react';
import SelectIndex from '../../form/selec-address/index';
import { getCountries } from './data';
import model from '../../assets/model';


class Country extends React.Component {
    state = {
        options: []
    }

    componentDidMount() {
        getCountries({parentPath:'',cardId:model.cardId},(data) => {
            this.setState({ options:data.optionList });
        });
    }

    render() {
        return (
            <SelectIndex 
                {...this.props} 
                options={this.state.options}
                onChange={this.props.onCountryChange}
            />
        );
    }
}

export default Country;


// WEBPACK FOOTER //
// ./src/component/Address/Country.js